import { useMemo } from 'react'
import { useParams, Link, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HiCalendar, HiArrowLeft } from 'react-icons/hi'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import { getVideoCollectionById } from '../../data/videosData'
import VkVideoEmbed from '../../components/VkVideoEmbed/VkVideoEmbed'
import SEO from '../../components/SEO/SEO'
import './VideoDetail.css'

function VideoDetail() {
  const { t, i18n } = useTranslation()
  const { collectionId } = useParams()
  const getLocalizedLink = useLocalizedLink()

  const collection = getVideoCollectionById(collectionId, i18n.language)

  const breadcrumbItems = useMemo(() => {
    if (!collection) return undefined
    return [
      { name: t('common.home'), pathSuffix: '' },
      { name: t('common.videos'), pathSuffix: 'videos' },
      { name: collection.title, pathSuffix: `videos/${collection.id}` },
    ]
  }, [collection, t])

  if (!collection) {
    return <Navigate to={getLocalizedLink('/videos')} replace />
  }

  return (
    <div className="video-detail-page">
      <SEO
        title={collection.title}
        description={collection.description.substring(0, 160)}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <Link to={getLocalizedLink('/videos')} className="video-detail-back">
          <HiArrowLeft className="back-icon" />
          <span>{t('videos.backToVideos')}</span>
        </Link>

        <article className="video-detail-article">
          {collection.image && (
            <div className="video-detail-image-wrapper">
              <img src={collection.image} alt={collection.title} className="video-detail-image" />
            </div>
          )}

          <div className="video-detail-header">
            <div className="video-detail-date">
              <HiCalendar className="date-icon" />
              <span>{collection.date}</span>
            </div>
            <h1 className="video-detail-title">{collection.title}</h1>
          </div>

          <div className="video-detail-content">
            <p className="video-detail-text">{collection.description}</p>

            <div className="video-detail-recordings">
              <h2 className="video-detail-recordings-title">{t('videos.recordingsTitle')}</h2>
              {collection.videos.map((video) => (
                <section
                  key={video.id}
                  id={`video-${video.id}`}
                  className="video-detail-section"
                >
                  <h3 className="video-detail-section-heading">{video.title}</h3>
                  <VkVideoEmbed url={video.url} title={video.title} />
                </section>
              ))}
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}

export default VideoDetail
